// extracted by mini-css-extract-plugin
export default {"cls1":"AdminBarActivator-cls1___5e6043e9e2ad5add659","cls2":"AdminBarActivator-cls2___4c1dbb3223b558ba219 AdminBarActivator-cls1___5e6043e9e2ad5add659"};